export function validatePassword(password: string): boolean {
    if (password.length < 8) {
        return false;
    }

    const hasLowercase = /[a-z]/.test(password);
    if (!hasLowercase) {
        return false;
    }

    const hasUppercase = /[A-Z]/.test(password);
    if (!hasUppercase) {
        return false;
    }

    const hasDigit = /[0-9]/.test(password);
    if (!hasDigit) {
        return false;
    }

    const hasSpecialChar = /[!@#$%^&amp;*()_+\-=\[\]{};':"\\|,.<&gt;\/?]/.test(password);

    return hasSpecialChar;
}
